<template>
    <div>
        <div class="card dashcard mb-0">
            
            <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>

                    <div class="col col-12 col-md-6">
                        <az-input
                            v-if="false"
                            placeholder="Todas as Formas..."
                            icon="fas fa-cash-register"
                            type="select"
                            optionsMode="aql"
                            service="forma_pagamentos.index"
                            optionsData="id_forma_pagamento"
                            optionsDisplay="search"
                            v-model="filtro.id_forma_pagamento" />

                        <az-input
                            placeholder="Selecionar paciente..."
                            icon="fas fa-user fa-fw"
                            type="autocomplete"
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="paciente"
                            :optimized_ac="true" />
                    </div>

                </div>

                <div class="form-row mt-2">

                    <div class="col col-12">
                        <az-input 
                            icon="fas fa-search" 
                            v-model="search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="false">
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="expandido = !expandido">
                                        <i class="fas fa-expand-arrows-alt fa-fw" v-if="!expandido"></i>
                                        <i class="fas fa-compress-arrows-alt fa-fw" v-else></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

            </div>

        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state 
            v-if="!lista_exibicao.length" 
            icon="fas fa-funnel-dollar"
            msg="Nenhum pagamento identificado." />

        <template v-else>
            <lista-adiantamentos :adiantamentos="dados" :search="search" :exibir_nome="true" />
        </template>

    </div>
</template>

<script>
// import _ from 'lodash';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import ListaAdiantamentos from '../recepcao/ListaAdiantamentos.vue';

export default {
    data() { 
        return { 
            dados: null, 
            search: "", 
            expandido: false, 
            viewMode: "A",
            fornecedores: [], 
            paciente: "", 
            filtro: { 
                periodo: "do", 
                id_forma_pagamento: "98", 
            }
        }
    },

    components: { 
        AzEmptyState, 
        AzInput, 
        AzPeriodo, 
        ListaAdiantamentos
    }, 

    computed: { 
        lista_exibicao: function () { 
            if ( !this.dados ) { 
                return [];
            }

            let reg = this.$util.getregex(this.search);

            return this.dados.filter(item => 
                ( !this.search || reg.test(JSON.stringify(item)))
            );
        },

        total_geral: function () { 
            return this.lista_exibicao.flatMap(item => item.item_pagamento_atendimentos)
                .reduce((total, carry) => { 
                    return total + carry.dc_valor;
                }, 0);
        }
    },

    methods: { 
        abrir_atendimento (id) { 
            this.$util.abrir_atendimento(this, id);
        },

        valor_total(pagamento) { 
            if ( !pagamento || !pagamento.item_pagamento_atendimentos ) { 
                return 0;
            }

            return pagamento.item_pagamento_atendimentos.reduce((total, carry) => { 
                return total + carry.dc_valor;
            }, 0);
        },

        load() { 
            this.$util.load(this, { 
                service: 'pagamentos', 
                func: 'lista_adiantamentos', 
                parms: { 
                    ...this.filtro, 
                }
            });
        },

        editar (item) { 
            this.$refs.lancamento.editar(item);
        },
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Financeiro", path: "/financeiro/visao" },
            { name: "Adiantamentos Particulares", path: "/financeiro/adiantamentos" }
        ]);

        this.load();
    }
}
</script>